import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { formatDate, DATE_FORMATS } from '@wix/da-ds/pkg/Time/functions';
const StatusMonoHtmlView = (props)=>{
    const { deviation , config: { link  }  } = props;
    return /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation), props.config && props.config.alignment && `daeditor-align-${props.config.alignment}`, props.settings && props.settings.showMediaAlwaysSmall && `daeditor-small`)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-body"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-date"
    }, deviation.publishedTime && formatDate(deviation.publishedTime, DATE_FORMATS.Date.Full)), /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-text"
    }, deviation.textContent && deviation.textContent.excerpt))));
};
StatusMonoHtmlView.displayName = 'StatusMonoHtmlView';
export default StatusMonoHtmlView;
